import { render, staticRenderFns } from "./edit_text.vue?vue&type=template&id=5a337094&scoped=true"
import script from "./edit_text.vue?vue&type=script&lang=js"
export * from "./edit_text.vue?vue&type=script&lang=js"
import style0 from "./edit_text.vue?vue&type=style&index=0&id=5a337094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a337094",
  null
  
)

export default component.exports